/**
 * Cliente HTTP tipado, gerado a partir do OpenAPI do FastAPI.
 *
 * `npm run api:generate` regenera `schema.gen.ts` — que nunca é editado à
 * mão. Drift entre o front e o back vira erro de compilação.
 */
import createClient, { type Middleware } from 'openapi-fetch';
import { getAccessToken } from '@/core/auth';
import { config } from '@/core/config';
import { ApiError } from './errors';
import type { paths } from './schema.gen';

export const api = createClient<paths>({ baseUrl: config.apiUrl });

const auth: Middleware = {
  async onRequest({ request }) {
    const token = await getAccessToken();
    if (token) request.headers.set('Authorization', `Bearer ${token}`);
    return request;
  },
};

api.use(auth);

type Result<D> = { data?: D; error?: unknown; response: Response };

/**
 * Desembrulha a resposta do openapi-fetch: devolve o corpo ou lança
 * `ApiError`. É o que permite ao TanStack Query tratar erro como erro.
 */
export async function unwrap<D>(request: Promise<Result<D>>): Promise<D> {
  let result: Result<D>;
  try {
    result = await request;
  } catch {
    throw ApiError.from(0, null);
  }
  if (!result.response.ok) throw ApiError.from(result.response.status, result.error);
  return result.data as D;
}

export type { paths, components } from './schema.gen';
